<template>
    <rkm-overlay>
        <template>
            <rkm-layout-body title="Histórico de atendimento">
                <template v-slot:actions>
                    <rkm-button
                        @click="exit"
                        color="danger"
                    >
                        Sair
                    </rkm-button>
                </template>

                <template v-slot:subtitle>
                    <div class="sub-title">
                        <template v-if="!!form">
                            <div>
                                <span v-if="!!form.paciente.nomeSocial">
                                    <strong class="sub-title-nome">{{form.paciente.nomeSocial}} (Nome social)</strong> {{form.paciente.nome}} |
                                </span>

                                <span v-else>
                                    <strong class="sub-title-nome">{{form.paciente.nome}}</strong> |
                                </span>

                                <span>{{form.paciente.sexoDescricao}}</span>
                            </div>

                            <div>
                                <template v-if="form.paciente.dataNascimento">
                                    <span>
                                        {{form.paciente.idadeAnos}} anos |
                                    </span>

                                    <span>
                                        Nasceu em {{form.paciente.dataNascimento}}
                                    </span>
                                </template>

                                <span>
                                    <strong>CPF</strong> {{form.paciente.cpf ? form.paciente.cpf : '-'}}
                                </span>

                                <span>
                                    <strong>CNS</strong> {{form.paciente.cns ? form.paciente.cns : '-'}}
                                </span>

                                <span>
                                    <strong>Nome da mãe</strong> {{form.paciente.nomeMae ? form.paciente.nomeMae : '-'}}
                                </span>

                                <span>
                                    <strong>Telefone</strong>&nbsp;

                                    {{form.paciente.telefoneNumero}}

                                    <template v-if="form.paciente.telefoneNumero.length === 15">
                                        (Autoriza SMS: {{form.paciente.telefoneAutorizaSms ? 'Sim' : 'Não'}})
                                    </template>
                                </span>
                            </div>
                        </template>
                    </div>
                </template>

                <rkm-layout-content :no-card-style="form && !form.paciente.isIdoso">
                    <Form
                        :id="id"
                        @loaded="loaded"
                        ref="Form"
                    />
                </rkm-layout-content>
            </rkm-layout-body>
        </template>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/ambulatorio/historico-atendimento/Form'

// Mixins.
import {error, repository} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {
        Form,
    },
    data: () => ({
        form: null,
    }),
    methods: {
        ...mapActions([
            'setLoading',
            'unsetLoading',
        ]),
        redirectToList() {
            this.$router.push('/ambulatorio/historico-atendimento/index')
        },
        loaded(value) {
            this.form = value.form
        },
        exit() {
            this.redirectToList()
        },
    },
    mixins: [error, repository],
    props: {
        id: {type: Number, required: true},
    },
}
</script>

<style scoped>
.sub-title {
    color: #222;
    font-size: 14px;
    text-transform: none !important;
}
.sub-title-link {
    font-size: 14px;
    text-transform: none !important;
    text-align: top;
    height: auto;
    margin-bottom: 3px;
    padding: 0;
}
.sub-title-nome {
    font-size: 18px;
}
</style>